import {createUseStyles} from 'react-jss'

const useStyles = createUseStyles((theme) => ({
	container: {
		display: 'flex',
	},
	sidebar: {
		flexShrink: '0',
		display: 'none',
		padding: '30px 0px 30px 30px',
		'@media screen and (min-width: 992px)': {
			display: 'flex',
			width: '240px',
		},
		flexDirection: 'column',
		alignItems: 'center',
	},
	description: {
		'& p': {
			lineHeight: '1.5',
			padding: '10px 0',
		}
	},
	h2: {
		textAlign: 'left',
		fontSize: '26px',
		padding: '15px 0px 10px',
	},
	columns: {
		columnCount: '2',
		columnGap: '60px',
		'& a': {
			lineHeight: '20px',
			marginBottom: '15px',
		}
	},
	center: {
		textAlign: 'center',
	},
	table: {
		margin: '10px auto 10px auto',
		'& thead': {
			fontWeight: 'bold',
			'& th, & td': {
				backgroundColor: '#337ab7',
				color: '#fff',
			},
			'& tr:first-child': {
				'& th, & td': {
					paddingTop: '5px',
				},
			},
			'& tr': {
				'& th, & td': {
					padding: '0px 7px',
				},
			},
			'& tr:last-child': {
				'& th, & td': {
					paddingBottom: '5px',
				},
			},
		},
		'& th, & td': {
			padding: '5px 7px',
		},
		'& thead tr, & tr:nth-child(even)': {
			backgroundColor: '#eee',
		},
	},
	limitWidth: {
		width: '100%',
		overflow: 'scroll',
		maxWidth: 'calc(100vw - 40px)',
		'@media screen and (min-width: 410px)': {
			maxWidth: 'calc(100vw - 80px)',
		},
		'@media screen and (min-width: 992px)': {
			maxWidth: 'calc(100vw - 360px)',
		},
		'@media screen and (min-width: 1200px)': {
			maxWidth: 'calc(100vw - 380px)',
		},
	},
}));

export default useStyles;
